
import { useAuthStore } from "@/stores/authStore";
import { defineComponent } from "vue";
export default defineComponent({
	setup() {
		const authStore = useAuthStore();
		const user = authStore.user as AuthUser;
		return {
			user,
			authStore
		};
	},
	name: "imdex-app-default"
});
